
import React, { useEffect } from "react";
import MobileNavItem from "./MobileNavItem";
import BookingButton from "./BookingButton";
import { NavItem } from "@/types/navbar";
import { Link } from "react-router-dom";

interface MobileMenuProps {
  isOpen: boolean;
  navItems: NavItem[];
  bookingUrl?: string;
  handleAnchorClick: (e: React.MouseEvent<HTMLAnchorElement>, hash: string) => void;
  onClose?: () => void;
}

const MobileMenu: React.FC<MobileMenuProps> = ({ 
  isOpen, 
  navItems, 
  bookingUrl = "https://zeeg.me/joerghoermann", 
  handleAnchorClick,
  onClose 
}) => {
  // Use effect to prevent body scrolling when menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, link: string) => {
    if (link.includes('#')) {
      handleAnchorClick(e, link.substring(link.indexOf('#')));
    }
    
    if (onClose) {
      onClose();
    }
  };

  if (!isOpen) return null;

  // All nav items are now treated equally

  return (
    <div 
      className="fixed inset-0 top-[64px] md:top-[80px] bg-[#2A333D] z-[100] overflow-auto"
      id="mobile-menu"
      role="dialog"
      aria-modal="true"
      aria-label="Hauptnavigation"
    >
      <div className="container py-6 px-4">
        <ul className="space-y-4 flex flex-col">
          {/* Navigation items */}
          {navItems.map((item) => (
            <li key={item.name} className="mobile-menu-item w-full">
              <MobileNavItem
                name={item.name}
                link={item.link}
                className="text-white hover:text-primary text-lg"
                onClick={(e) => handleNavClick(e, item.link)}
              />
            </li>
          ))}
          
          <li className="mt-8 w-full">
            <BookingButton url={bookingUrl} isMobile={true} />
          </li>
        </ul>
      </div>
    </div>
  );
};

export default MobileMenu;
